import { AppConfig } from "@/contexts/AppConfigContext";
import { LoginResponse } from "./Auth.typed";

export class AuthModel {
  private apiBase: string;

  constructor(config: AppConfig) {
    this.apiBase = config.assignementsAPI;
  }

  /**
   * Performs a login request to retrieve a JWT.
   * @param username - Username
   * @param password - Password
   * @returns Token payload and expiration
   */
  async login(username: string, password: string): Promise<LoginResponse> {
    const response = await fetch(`${this.apiBase}/v1/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
      throw new Error(`Failed to login: ${response.statusText}`);
    }

    const data: LoginResponse = await response.json();
    return data;
  }
}
